// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 26) return "./default/chunk-html-box-reg-wall.019c84833a4304c551f6.js";
	if (chunkId === 36) return "./default/chunk-recombee-init.45a52aa4ade6560f578f.js";
	if (chunkId === 27) return "./default/chunk-lazyload-images.7f4fe58a8dfb2841e7db.js";
	if (chunkId === 24) return "./default/chunk-gtm-highlight.0d6f3a3ee213168ebd18.js";
	if (chunkId === 34) return "./default/chunk-progressBar.8ce7aeff225bb137a21e.js";
	if (chunkId === 16) return "./default/chunk-accordion.84df9e42bbde316f473b.js";
	if (chunkId === 21) return "./default/chunk-fadeInOnEnterViewport.bfb84362ed92555616df.js";
	if (chunkId === 30) return "./default/chunk-megamenu.af32d66f086b91a39de5.js";
	if (chunkId === 25) return "./default/chunk-header.bd3389f53fb5002625e4.js";
	if (chunkId === 29) return "./default/chunk-mainNavigation.08332d3e998e91b8a193.js";
	if (chunkId === 31) return "./default/chunk-modal.b4b02859d3efd8ba3ce2.js";
	if (chunkId === 68) return "./68.f14e3e503b758670201b.js";
	if (chunkId === 23) return "./default/chunk-gallery.203550a50da5e371d1b8.js";
	if (chunkId === 20) return "./default/chunk-enquiry.d06c4e7a2a23d48da351.js";
	if (chunkId === 40) return "./default/chunk-survey.bdb7019303232077600b.js";
	if (chunkId === 22) return "./default/chunk-forum.50da6ba3216e8d0e6e36.js";
	if (chunkId === 64) return "./64.b4701945b4be2b72c263.js";
	if (chunkId === 35) return "./default/chunk-recombee.5123607f9484c0f8566e.js";
	if (chunkId === 65) return "./65.6792d92e2293fe2b7b54.js";
	if (chunkId === 28) return "./default/chunk-load-more.60cbb334838cd2c1a286.js";
	if (chunkId === 42) return "./default/chunk-uncover-behav-articles.d35fed0c4e8db8d3a998.js";
	if (chunkId === 17) return "./default/chunk-ads-repeater.4e5da9316164a60aeb10.js";
	if (chunkId === 49) return "./default/newsletter.fc6d92bbeca7c1fc5eb1.js";
	if (chunkId === 44) return "./default/companySubscription.d6b3e5f23bf19786380e.js";
	if (chunkId === 53) return "./default/swiper.7443321ba761b4fc25a2.js";
	if (chunkId === 55) return "./default/thingsArticleSwiper.7831959716e7ee6363c7.js";
	if (chunkId === 19) return "./default/chunk-editorial-promo.6021e68e3679a2312e34.js";
	if (chunkId === 56) return "./default/topic-banner.79e2e836a9daad8509f6.js";
	if (chunkId === 47) return "./default/instagram.b013bfbd23474f43f70c.js";
	if (chunkId === 50) return "./default/piano.a8b29f858458f1da034c.js";
	if (chunkId === 66) return "./66.f9381b8ddb6e14746516.js";
	if (chunkId === 51) return "./default/portaInit.dc57e8f6b0e200e17fd5.js";
	if (chunkId === 48) return "./default/jakebox.d4ce267e98c1626c10db.js";
	if (chunkId === 43) return "./default/collapser.0e6c27d653e0b182d5ea.js";
	if (chunkId === 15) return "./default/author-card-list.30b94a77c93aa48b3946.js";
	if (chunkId === 52) return "./default/rename-article-list.3dbc29417403440c43c0.js";
	if (chunkId === 13) return "./chunk-todayResultSliderHP.46b6d4c84779eadded5c.js";
	if (chunkId === 7) return "./chunk-previewMatchesListVideoSlider.7d110591fea579d517ac.js";
	if (chunkId === 5) return "./chunk-headermenuflat.824c1743526326ab4ac3.js";
	if (chunkId === 46) return "./default/info-toggle.c2d1975fe467a69e227c.js";
	if (chunkId === 54) return "./default/tabs.5d8e04a1e9b9f3c889ec.js";
	if (chunkId === 12) return "./chunk-sportmodDayResultDatepicker.3d576feb17b234e86264.js";
	if (chunkId === 67) return "./67.965027227258d4b3bc7b.js";
	if (chunkId === 9) return "./chunk-sportmod-live-match-websocket-updater.a3d1a6070a4b06800a5f.js";
	if (chunkId === 8) return "./chunk-sportmod-league-phase-reloader.a967bf1b5ec43f4c343a.js";
	if (chunkId === 10) return "./chunk-sportmod-matches-with-table-phase-reloader.4150daeebbb120849074.js";
	if (chunkId === 11) return "./chunk-sportmod-team-matches-toggle.c2d7a8b137ef3db55777.js";
	if (chunkId === 4) return "./chunk-category-content-loader.5e2d2973dc90f01f915a.js";
	if (chunkId === 14) return "./chunk-top-feed-responsive-behavior.186a9a30d5d440b469a5.js";
	// return url for filenames based on template
	return undefined;
};